module.exports = __webpack_public_path__ + "static/media/CyberSecurityImg.0fc61264.png";